import { render, staticRenderFns } from "./WorkEdit.vue?vue&type=template&id=5979ad36&"
import script from "./WorkEdit.vue?vue&type=script&lang=js&"
export * from "./WorkEdit.vue?vue&type=script&lang=js&"
import style0 from "./WorkEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports